export const HEADER = 'Not sure where to invest?';
// export const DESCRIPTION = 'Discover funds basis your risk profile';
//export const HEADER = 'Axis Bank Select Funds';
export const HEADER1 = 'Funds with moderate to high returns';
export const DESCRIPTION = 'Discover Axis Bank Select Funds based on your profile and goals';
export const DESCRIPTION1 = 'Discover Axis Bank Select Funds basis risk-return combination';
export const BUTTON_NAMING = 'Explore';
